export const borderRadius = {
    sm: '4px',
    md: '8px',
    lg: '10px',
    xl: '20px',
};
